var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "#AAA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    fill: "inherit"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 5,
    r: 1,
    fill: "inherit"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 1,
    r: 1,
    fill: "inherit"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 1,
    fill: "inherit"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 1,
    r: 1,
    fill: "inherit"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 1,
    fill: "inherit"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag-handle.f9caa7c0dccaae5859ce4bda47b6ac4a.svg";
export { ForwardRef as ReactComponent };